/**
 * 是否在数组中
 * @param array
 * @param key
 * @returns {boolean}
 */
export const inArray = (array,key)=>{
	return array.indexOf(key) > -1
}
